var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('C1Button',{attrs:{"type":"button","variant":"secondary","size":_vm.size,"disabled":_vm.isSaved,"block":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.click()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }